import { useMemo } from 'react';
import { HERO_MEASURE, HERO_TEXT, HERO_VALUES, heroPassports } from './fixtures/kestrelHero';
import { propertyById } from './fixtures/kestrelOntology';
import useKestrel from './useKestrel';

/**
 * The hero story's data, from the Kestrel dataset's one clock: the pack
 * unit's level and the Kestrel ontology (the one every Home vignette shows),
 * the two properties the story fills (`measure`, `text`) with the values
 * typed into them, and the passport at any point of the story, worked out
 * once per stage (see fixtures/kestrelHero.js; its public page is
 * fixtures/kestrelHeroPage.js).
 */
export default function useHeroData() {
    const kestrel = useKestrel();

    return useMemo(() => ({
        kestrel,
        clock: kestrel.clock,
        ontology: kestrel.ontology,
        node: kestrel.ontology.data[kestrel.pack.currentNode],
        measure: propertyById(HERO_MEASURE),
        text: propertyById(HERO_TEXT),
        values: HERO_VALUES,
        passport: heroPassports(kestrel.clock),
    }), [kestrel]);
}
